module.exports = __webpack_public_path__ + "img/price.ae003527.png";